"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Row = void 0;
var styled_components_1 = require("styled-components");
var Theme_1 = require("../../../Theme");
var calculateBackgroundColor = function (props) {
    if (props.IsSelected) {
        return Theme_1.Color.Blue.B60;
    }
    else if (props.IsHovered) {
        return Theme_1.Color.Blue.B20;
    }
    else {
        return "white";
    }
};
exports.Row = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 4px 8px;\n    align-items: center;\n    box-sizing: border-box;\n    height: 100%;\n    display: grid;\n    align-items: center;\n\n    background-color: ", ";\n"], ["\n    padding: 4px 8px;\n    align-items: center;\n    box-sizing: border-box;\n    height: 100%;\n    display: grid;\n    align-items: center;\n\n    background-color: ", ";\n"])), calculateBackgroundColor);
var templateObject_1;
